var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.mode == "edit"
        ? _c(
            "el-select",
            {
              ref: _vm.reference,
              staticClass: "wp-10",
              attrs: {
                filterable: "",
                multiple: "",
                placeholder: _vm.prop.placeholder
              },
              on: { "remove-tag": _vm.remove },
              model: {
                value: _vm.tmpValue,
                callback: function($$v) {
                  _vm.tmpValue = $$v
                },
                expression: "tmpValue"
              }
            },
            _vm._l(_vm.prop.allowedValues, function(item) {
              return _c("el-option", {
                key: item.id,
                attrs: { label: item.name, value: parseInt(item.id) }
              })
            }),
            1
          )
        : _c("p", [
            _vm._v("\n        " + _vm._s(_vm.concatenatedValues) + "\n    ")
          ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }